import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, tomos, tomoIncludes } from '../data/tomos';
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-163" data-mp="1h2udoj7py5gp">
      <div className="mx-auto max-w-6xl px-5 pb-8 pt-5" data-id="element-164" data-mp="1h4dv4d542mk2">
        <div className="text-center" data-id="element-165" data-mp="1cc46r1jn9ujw">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-bordo-light" data-id="element-166" data-mp="1cb2uwuut1414">
            AMIGURUMI BUSINESS PACK
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-silver-shine sm:text-4xl" data-id="element-167" data-mp="1m2fn5nkilw7o">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-168" data-mp="200ni5pxzqng7">+100 páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-169" data-mp="1w1emugnayhij">
            {pillars.map(p => <span key={p} className="rounded-full border border-bordo-soft/50 bg-bordo/20 px-3 py-1 text-xs font-bold uppercase tracking-wide text-plata-soft" data-id="element-170" data-mp="5op67g8ardgm">
                {p}
              </span>)}
          </div>
          <p className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-plata" data-id="element-171" data-mp="39p1fghbuls2w">
            📚 Los 12 tomos estratégicos
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-172" data-mp="3emt9bgw1zo9q">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="rounded-2xl border border-white/10 bg-ink-2 p-5" data-id="element-173" data-mp="3jhfm9ohs9ovx" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-174" data-mp="67rjbyggpkc3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-bordo/30 font-display text-lg font-black text-plata-soft" data-id="element-175" data-mp="231me4tsof6yk">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-176" data-mp="200t30xvwwwp3">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-177" data-mp="1vzhgj18c4rl4">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-bordo-soft/40 bg-ink-2 p-6" data-id="element-178" data-mp="29vkzfydrddia">
          <p className="text-center font-display text-lg font-black text-plata-soft" data-id="element-179" data-mp="250xhyjh69jd7">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="2exa857didf37">
            {tomoIncludes.map(item => <li key={item.label} className="flex items-start gap-2 text-sm text-white/75" data-id="element-181" data-mp="2soovtrid24gl">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-bordo-light" strokeWidth={3} aria-hidden="true" data-id="element-182" data-mp="2np2gnciz2e55" />
                <span data-id="element-183" data-mp="2xnrxd1z4tsjt">
                  <span className="font-semibold text-white" data-id="element-184" data-mp="2xokztqr25vw5">{item.label}</span>
                  <span className="block text-xs text-white/50" data-id="element-185" data-mp="3h8s9fmb2cuc4">{item.detail}</span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}